export enum SplitColumn {
  left = 0,
  right = 1,
}
